import React from 'react';
import { connect } from "react-redux";
import getClientInfo from '../../../API/Admin/GetClient'
import Loader from '../../../Global/loader'
import Tabs from './tabs.js'
import logout from '../../../Global/logout'

export class ClientDetails extends React.Component{
	constructor(props) {
		super(props);
	
		document.title= "Klijent - Detalji"
		this.state={
            loading: true,
            clientName: ""
		} 
	}
    componentDidMount = async () => {		
        this.setState({
            loading: true
        })

        let url = window.location.hash
        let urldivided = url.split(":")

        let clientInfo = await getClientInfo(urldivided[1])
        if(clientInfo.error !== null){
            logout()
        }

        await this.props.mapState("ADMIN_MAP_ONE_CLIENT_DETAILS", clientInfo.data)

        await this.setState({            
            clientName: clientInfo.data.clientName,
            loading: false       
        })
    }
    
    goBack(){
        window.location = "#/Admin/client/"
    }

    render(){  
      
        return(  
            <>
            {this.state.loading ?
                <div style={{position: "sticky", marginTop: "50px", left: "50%"}}>
                    <Loader />
                </div>
            :  
                <main style={{}}>                   
                    <header>
                        <h1>
                            {this.state.clientName}
                        </h1>      
                    </header>

                    <Tabs />
                </main>
            }
            </>
        )
    }  
}

const mapStateToProps = state => {
    return {
        asideToggled: state.client.asideToggled,
        oneClientInfo: state.adminClient.oneClient

    };
  };
  
  const mapDispatchToProps = dispatch => {
    return {
      mapState: (type, data) => dispatch({ type: type, data: data}),
      API: (type, data) => dispatch({ type: type, data: data})
    };
  };
  
  
  
  export default connect(
    mapStateToProps,
    mapDispatchToProps
  )(ClientDetails);
